import { COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const SecurityPoliciesColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Type",
        accessor: "profileSubType",
        isNumeric: false,
        id: 1,
        sortByName: "profileSubType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
    }
];

export default SecurityPoliciesColumns;
